import { useParams } from "@tanstack/react-router";
import AtelierForm from "@features/creation/ateliers/components/AtelierForm";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Pencil } from "lucide-react";
import { useAtelierDetail } from "@features/creation/ateliers/hooks/useAteliers";

export const Route = createFileRoute("/_app/creation/ateliers/$id/edit")({
  loader: requirePermission(PERMISSIONS.CREATION.ATELIERS.EDIT),
  staticData: {
    title: "Modifier l'atelier",
    icon: Pencil,
    permission: PERMISSIONS.CREATION.ATELIERS.EDIT,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: EditAtelierPage,
});

function EditAtelierPage() {
  const { id } = useParams({ from: "/_app/creation/ateliers/$id/edit" });
  const { data: atelier, isLoading } = useAtelierDetail(id);

  if (isLoading) {
    return (
      <div className="max-w-3xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">Modifier l'atelier</h1>
        </div>
        <div className="space-y-4">
          <div className="skeleton h-12 w-full" />
          <div className="skeleton h-24 w-full" />
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Modifier l'atelier</h1>
        <p className="text-sm text-base-content/60">
          Modifier les informations de l'atelier {atelier?.code}
        </p>
      </div>
      <AtelierForm atelier={atelier} />
    </div>
  );
}
